var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { title: _vm.params.value } }, [
    _vm.showLink
      ? _c("div", [
          _c("a", { attrs: { href: _vm.link } }, [
            _vm._v("\n      " + _vm._s(_vm.params.value) + "\n    "),
          ]),
        ])
      : _c("div", [_vm._v("\n    " + _vm._s(_vm.display) + "\n  ")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }